import Vue from 'vue'
import NewMessageBox from '@/components/new_message_box/index'

const MessageBoxObject = Vue.extend(NewMessageBox)

NewMessageBox.install = function(data) {
  if ( typeof data !== 'object' || typeof data === null ) {
    throw new Error('參數類型必須為對象')
  }
  let instance = new MessageBoxObject({
    data
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show = true
  })

  return instance.confirm()
}

export default NewMessageBox